var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('v-ons-modal',{attrs:{"visible":_vm.modalVisible}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(" 更新中 "),_c('v-ons-icon',{attrs:{"icon":"fa-spinner","spin":""}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }